import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="flex items-center justify-center mb-4">
            <FileText className="w-8 h-8 text-primary-400 mr-2" />
            <span className="text-2xl font-bold">Ainix Invoice</span>
          </div>
          <p className="text-gray-400 mb-4">
            Professional invoice generation made simple
          </p>
          <div className="flex justify-center space-x-6">
            <Link to="/login" className="text-gray-400 hover:text-white">
              Sign In
            </Link>
            <Link to="/register" className="text-gray-400 hover:text-white">
              Sign Up
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
